module.exports = __webpack_public_path__ + "static/media/24-4.17db4244.mp3";